import React from 'react';
import { observer } from 'mobx-react';
import { Text, Icon, Box, Flex } from 'core/components';

import ResultMenuItem from './ResultMenuItem';

function CostSnapshot({ item, selected, query, IconCmp, onItemClick, ...rest }) {
  const { id, name, path } = item;

  return (
    <ResultMenuItem
      {...rest}
      selected={selected}
      onClick={() => onItemClick({ type: 'costSnapshot', id, path }, 'Search Results')}
    >
      <Flex gridArea="icon" alignItems="center" justifyContent="center">
        <IconCmp iconSize={22} />
      </Flex>

      <Box gridArea="title">
        <Text className="title">{name}</Text>
      </Box>

      <Flex gridArea="rightIcon" alignItems="center" justifyContent="center">
        <Icon icon={selected ? 'key-enter' : undefined} color="#ffffff" />
      </Flex>
    </ResultMenuItem>
  );
}

export default observer(CostSnapshot);
